import React from 'react';
import ReactDOM from 'react-dom';
import App from './Components/App';
import { BrowserRouter } from 'react-router-dom';
//ReactDOM.render( < BrowserRouter  >
//ReactDOM.render( < BrowserRouter basename = '/ampliass' >
ReactDOM.render( < BrowserRouter  >
     <App />
   </BrowserRouter> , document.getElementById('root'));